import BookingApi from "../../repository/api/BookingApi";
import Logger from "../../utils/Logger";
import DpjpApi from "../../repository/api/DpjpApi";
import DepartementApi from "../../repository/api/DepartementApi";
import TeachingMaterialsApi from "../../repository/api/TeachingMaterialsApi";
import PenilaianApi from "../../repository/api/PenilaianApi";
import Vue from 'vue'
import KoasApi from "../../repository/api/KoasApi";

const state = () => ({
    status: [],
    dpjp: [],
    dpjpSchedule: [],
    department: [],
    teachingMaterials: [],
    refPenilaian: [],
    koas: [],
})

const getters = {
    hasStatus: (state, getters, rootState) => {
        return state.status.length > 0
    },

    hasDpjp: (state, getters, rootState) => {
        return state.dpjp.length > 0
    },

    hasDepartment: (state, getters, rootState) => {
        return state.department.length > 0
    },

    hasTeachingMaterials: (state, getters, rootState) => {
        return state.teachingMaterials.length > 0
    },

    status: (state, getters, rootState) => {
        return state.status
    },

    statusByCode: (state) => (code) => {
        if (code.startsWith('0'))
            return '-'

        return state.status.find(x => x.code === code)
    },

    dpjp: (state, getters, rootState) => {
        return state.dpjp
    },

    koas: (state, getters, rootState) => {
        return state.koas
    },

    dpjpSchedule: (state, getters, rootState) => {
        return state.dpjpSchedule
    },

    department: (state, getters, rootState) => {
        return state.department
    },

    teachingMaterials: (state, getters, rootState) => {
        return state.teachingMaterials
    },

    refPenilaian: (state, getters, rootState) => {
        return state.refPenilaian
    },
}

const actions = {
    getStatus({ state, commit }) {
        if (state.status.length > 0)
            return

        BookingApi.getStatus()
            .then(r => {
                commit('setStatus', r)
            })
            .catch(e => {
                Vue.swal({
                    icon: e.severity || "error",
                    title: (e.severity || "error").toUpperCase(),
                    text: e.message,
                })

                Logger.e(`Error waktu ambil status : ${e}`)
            })
    },

    getDpjp({ state, commit }) {
        if (state.dpjp.length > 0)
            return

        DpjpApi.get()
            .then(r => {
                commit('setDpjp', r)
            })
            .catch(e => {
                Vue.swal({
                    icon: e.severity || "error",
                    title: (e.severity || "error").toUpperCase(),
                    text: e.message,
                })

                Logger.e(`Error waktu ambil status : ${e}`)
            })
    },

    getKoas({ state, commit }) {
        if (state.dpjp.length > 0)
            return

        KoasApi.get()
            .then(r => {
                commit('setKoas', r)
            })
            .catch(e => {
                Vue.swal({
                    icon: e.severity || "error",
                    title: (e.severity || "error").toUpperCase(),
                    text: e.message,
                })

                Logger.e(`Error waktu ambil status : ${e}`)
            })
    },

    getDpjpSchedule({ state, commit }) {
        if (state.dpjpSchedule.length > 0)
            return

        DpjpApi.getSchedule()
            .then(r => {
                commit('setDpjpSchedule', r)
            })
            .catch(e => {
                Vue.swal({
                    icon: e.severity || "error",
                    title: (e.severity || "error").toUpperCase(),
                    text: e.message,
                })

                Logger.e(`Error waktu ambil status : ${e}`)
            })
    },

    getDepartment({ state, commit }) {
        if (state.department.length > 0)
            return

        DepartementApi.get()
            .then(r => {
                commit('setDepartment', r)
            })
            .catch(e => {
                Vue.swal({
                    icon: e.severity || "error",
                    title: (e.severity || "error").toUpperCase(),
                    text: e.message,
                })

                Logger.e(`Error waktu ambil status : ${e}`)
            })
    },

    getTeachingMaterials({ state, commit }) {
        if (state.teachingMaterials.length > 0)
            return

        TeachingMaterialsApi.get()
            .then(r => {
                commit('setTeachingMaterials', r)
            })
            .catch(e => {
                Vue.swal({
                    icon: e.severity || "error",
                    title: (e.severity || "error").toUpperCase(),
                    text: e.message,
                })

                Logger.e(`Error waktu ambil status : ${e}`)
            })
    },

    getRefPenilaian({ state, commit }) {
        if (state.refPenilaian.length > 0)
            return

        PenilaianApi.getRef()
            .then(r => {
                commit('setRefPenilaian', r)
            })
            .catch(e => {
                Vue.swal({
                    icon: e.severity || "error",
                    title: (e.severity || "error").toUpperCase(),
                    text: e.message,
                })

                Logger.e(`Error waktu ambil status : ${e}`)
            })
    },

    setStatus({ state, commit }, items) {
        commit('setStatus', items)
    },

    setDpjp({ state, commit }, items) {
        commit('setDpjp', items)
    },

    setDepartment({ state, commit }, items) {
        commit('setDepartment', items)
    },

    setTeachingMaterials({ state, commit }, items) {
        commit('setTeachingMaterials', items)
    },

    setRefPenilaian({ state, commit }, items) {
        commit('setRefPenilaian', items)
    },
}

const mutations = {
    setStatus(state, items) {
        state.status = items
    },

    setDpjp(state, items) {
        state.dpjp = items
    },

    setKoas(state, items) {
        state.koas = items
    },

    setDpjpSchedule(state, items) {
        state.dpjpSchedule = items
    },

    setDepartment(state, items) {
        state.department = items
    },

    setTeachingMaterials(state, items) {
        state.teachingMaterials = items
    },

    setRefPenilaian(state, items) {
        state.refPenilaian = items
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}